<template>
  <div class="spare_parts_detail">
    <a-descriptions bordered size="small" title="备件基本信息">
      <a-descriptions-item label="物料描述" :span="2">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="物料号">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="基本计量单位">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="行业领域">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="物件类型">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="物料组">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="毛重">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="净重">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="重量单位">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="所属公司">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="数量">{{ detail.xxx }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions bordered size="small" title="采购视图">
      <a-descriptions-item label="采购组">{{ detail.xxx }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions bordered size="small" title="财务视图">
      <a-descriptions-item label="评估类">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="价格确定" :span="2">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="价格控制">{{ detail.xxx }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions bordered size="small" title="销售视图">
      <a-descriptions-item label="项目类别组">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="可用性检查" :span="2">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="交货工厂">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="科目设置组" :span="2">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="销售组" :span="3">{{ detail.xxx }}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('watch_record', model)
        this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {
        xxx: 'xxxxxx'
      }
    }
  },
  methods: {
    initDetail (model) {
      const params = {}
    }
  }
}
</script>

<style lang="less" scoped>
.spare_parts_detail{
  margin-left: -1px;
  margin-right: -1px;
  /deep/.ant-descriptions{
    margin-bottom: -1px;
    .ant-descriptions-title{
      margin-bottom: 0;
      line-height: 32px;
      font-size: 12px;
      color: #08409F;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      padding: 0 12px;
      border-right: 1px solid #DDDDDD;
      // border-left: 1px solid #e8e8e8;
      background: #FFFFFF;
    }
    .ant-descriptions-view{
      border-radius: 0;
      width: 100%;
      border-color: #DDDDDD;
      // border-left: none;
      // border-right: none;
      .ant-descriptions-row{
        border-bottom: none;
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          padding: 8px 12px;
          height: 40px;
          border-bottom: 1px solid #DDDDDD;
          border-color: #DDDDDD;
        }
        .ant-descriptions-item-label{
          background: rgba(8,64,159,0.1);
          width: calc(100% / 9);
        }
        .ant-descriptions-item-content[colspan="1"]{
          // width: 230px;
          width: calc(100% / 9 * 2);
        }
        .ant-descriptions-item-content[colspan="3"]{
          // width: 580px;
          width: calc(100% / 9 * 5);
        }
        .ant-descriptions-item-content[colspan="5"]{
          // width: 930px;
          width: calc(100% / 9 * 8);
        }
      }
      .ant-descriptions-row:last-child{
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          // border-bottom: none;
        }
      }

    }
  }
  /deep/.ant-descriptions:last-child{
    .ant-descriptions-view{
      border-bottom: none;
    }
  }
}
</style>
